import "./FieldInput.scss";

import { Component, h, render } from "preact";

export function FieldInput({
  onChange,
  value = "",
  label = "",
  required = false,
  type = "text",
  hint = "",
}) {
  return (
    <div className="CCFieldInput t-text">
      {label && <label className="CCFieldInput__label">{label}</label>}

      <input
        type={type}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        className="CCFieldInput__input t-text"
        required={required}
      />

      {hint && <div className="CCFieldInput__hint t-text">{hint}</div>}
    </div>
  );
}
